import React, {useState} from "react";
import "./comparisonSideMenu.css";
import {Link} from "react-scroll";

const ComparisonSideMenu = ({ sideMenu, currentActive }) => {
    const [activeLink, setActiveLink] = useState(currentActive);
    const handleSetActive = (link) => {
        setActiveLink(link);
    };

    return (<>
        {sideMenu.map((singleMenu, index) => (
            <Link
                key={index}
                to={singleMenu.link}
                className={activeLink === singleMenu.link ? "active-link" : ""}
                onClick={() => handleSetActive(singleMenu.link)}
                smooth={true}
                duration={500}
                offset={-90}
            >
                {singleMenu.name}
            </Link>
        ))}
    </>);
};

export default ComparisonSideMenu;
